import { trans } from '@spotahome/soyuz/client';

import openDepositProtectionModal from '@spotahome/ui-library/src/tenant/components/DepositProtectionModal';
import LockSmall from '@spotahome/ui-library/src/tenant/components/icons/LockSmall';

import './WorryFreeDeposit.scss';

const WorryFreeDeposit = () => (
  <div className="worry-free-deposit">
    <div className="worry-free-deposit__icon">
      <LockSmall />
    </div>
    <div className="worry-free-deposit__content">
      <p id="worry-free-deposit-title" className="worry-free-deposit__title">
        {trans('listing.worry-free-deposit.title')}
      </p>
      <button
        type="button"
        className="worry-free-deposit__link"
        aria-describedby="worry-free-deposit-title"
        onClick={openDepositProtectionModal}
      >
        {trans('listing.worry-free-deposit.learn-more')}
      </button>
    </div>
  </div>
);

export default WorryFreeDeposit;
